import React from "react";
import { UserCheck, ShieldCheck } from "lucide-react";
import { WooCommerceAccountBlock } from "@/integrations/wordpress/WooCommerceAccountBlock";
export default function Account() {
  return <section id="account-content" data-nav="dark" className="relative w-full bg-background text-foreground py-12 md:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Technical Header & Precision Marker */}
        <div className="mb-8 md:mb-12 border-b border-border pb-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <span className="h-2 w-2 bg-primary rounded-xs" />
                <span className="font-mono text-xs uppercase tracking-wider text-muted-foreground">
                  Verified Portal // Terminal 01
                </span>
              </div>
              <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight text-foreground flex items-center gap-3">
                <span className="inline-block w-1.5 h-8 sm:h-10 bg-primary rounded-xs" />
                Customer Account
              </h1>
            </div>

            <div className="flex items-center gap-3 bg-card border border-border px-3.5 py-2 rounded-xs shadow-xs">
              <ShieldCheck className="size-4 text-primary" />
              <span className="font-mono text-xs text-muted-foreground">
                256-Bit Encrypted Session
              </span>
            </div>
          </div>
        </div>

        {/* Account Interface Container */}
        <div className="bg-card border border-border rounded-xs p-4 sm:p-6 md:p-8 shadow-md relative overflow-hidden">
          <div className="absolute top-0 right-0 w-24 h-24 bg-primary/5 rounded-bl-full pointer-events-none" />
          
          <div className="relative z-10">
            <WooCommerceAccountBlock />
          </div>
        </div>

        {/* Technical Footer Note */}
        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 text-xs font-mono text-muted-foreground border-t border-border pt-4">
          <div className="flex items-center gap-2">
            <UserCheck className="size-3.5 text-primary" />
            <span>Huga Scalet Industrial Equipment Depot</span>
          </div>
          <span>Account Dispatch & Order Records</span>
        </div>
      </div>
    </section>;
}